import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <p className="section-tag">CONTACT US</p>
        <h2 className="section-heading">Have a question or need a custom quote?</h2>
        <div className="contact-grid">
          <div className="contact-left-card">
            <div className="contact-phone-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="white"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
            </div>
            <p className="contact-open-text">We are open 24 hours throughout the year.</p>
            <div className="contact-number-badge">Call us anytime at 02038393300</div>
            <p className="contact-support-text">Fast support for instant booking and custom quotes.</p>
          </div>
          <div className="contact-right-grid">
            <div className="contact-info-card">
              <span className="info-label">CALL</span>
              <span className="info-value">02038393300</span>
            </div>
            <div className="contact-info-card">
              <span className="info-label">EMAIL</span>
              <span className="info-value">info@taxicabs-247.co.uk</span>
            </div>
            <div className="contact-info-card">
              <span className="info-label">WHATSAPP</span>
              <span className="info-value">07365874733</span>
            </div>
            <div className="contact-info-card">
              <span className="info-label">ADDRESS</span>
              <span className="info-value">UK</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
